var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.9 76.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#fff;stroke-width:0.9px;}.cls-3{stroke:#018b9d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Note") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.45,
    cy: 38.45,
    r: 32.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.45,
    cy: 38.45,
    r: 38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "60.06 27.56 36.98 50.64 31.43 52.49 33.28 46.95 56.37 23.86 60.06 27.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "54.52 25.71 52.67 23.86 48.06 28.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.38,
    y1: 22.22,
    x2: 41.89,
    y2: 22.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "30.14 22.22 21.65 22.22 21.65 58.13 50.38 58.13 50.38 42.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.63 20.26 38.63 17.65 33.4 17.65 33.4 20.26 30.79 20.26 29.48 25.48 42.54 25.48 41.24 20.26 38.63 20.26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.f3df0d00f62755e660f42bdc6958d523.svg";
export { ForwardRef as ReactComponent };